import { render, staticRenderFns } from "./HomeFeaturedLink.vue?vue&type=template&id=c62552e4&scoped=true"
import script from "./HomeFeaturedLink.vue?vue&type=script&lang=js"
export * from "./HomeFeaturedLink.vue?vue&type=script&lang=js"
import style0 from "./HomeFeaturedLink.vue?vue&type=style&index=0&id=c62552e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62552e4",
  null
  
)

export default component.exports